import React from 'react';
import { MODAL_ICONS } from '../../../../constants/defaultValues';
import styles from './Icon.module.scss';

const Icon = ({ iconKey, className }) => {
    const ModalIcon = MODAL_ICONS[iconKey];

    return ModalIcon ? <ModalIcon className={`${styles.icon} ${className} `} /> : null;
};

export default Icon;
